module.exports = __webpack_public_path__ + "static/media/mobile_nav_waves.9bde51b8.svg";